// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__37zbu","label":"SetPasswdForm_label__Mf_sP"};